<template>
  <div class="search-page">
    <section class="page-banner assets-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <div class="search-layout-centered">
          <h1>全文检索</h1>
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>全文检索</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </section>
    <section class="search-section">
      <div class="container">
        <!-- Center layout wrapper -->
        <div class="search-layout-centered">
          <!-- Search Area (Filter Style like Assets.vue) -->
          <div class="filter-section-wrapper">
            <div class="filter-box">
              <!-- Search Row -->
              <div class="filter-row search-row">
                <div class="search-box-assets">
                  <input type="text" placeholder="请输入关键词进行检索..." v-model="searchForm.keyword" @keyup.enter="handleSearch">
                  <button class="btn-search" @click="handleSearch"><i class="el-icon-search"></i> 检索</button>
                </div>
              </div>

              <!-- Module Filter Row -->
              <div class="filter-row">
                <div class="filter-group">
                  <label>资料库：</label>
                  <div class="filter-options">
                    <el-radio-group v-model="searchForm.searchType" size="small" @change="handleSearch">
                      <el-radio label="">全部</el-radio>
                      <el-radio label="AuctionAsset">在拍资产</el-radio>
                      <el-radio label="BadAsset">资产推介</el-radio>
                      <el-radio label="AyContent">资讯中心</el-radio>
                      <el-radio label="CmsRecruitment">人才招聘</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <!-- Date Filter Row -->
              <div class="filter-row">
                <div class="filter-group">
                  <label>发布时间：</label>
                  <div class="filter-options">
                    <el-date-picker
                      v-model="dateRange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      size="small"
                      style="width: 100%; max-width: 350px;"
                      @change="handleSearch"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="filter-actions">
                  <el-button type="primary" class="saixuan"  icon="el-icon-set-up" @click="handleSearch">筛选</el-button>
                  <el-button  icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </div>
              </div>

            </div>
          </div>

          <!-- Search Results List -->
          <div class="search-results" v-loading="loading">
            <div class="result-header">
              <span>找到约 <strong style="color: #1a4a7a;">{{ total }}</strong> 条相关结果</span>
            </div>
            
            <div class="result-list" v-if="resultList.length > 0">
              <div class="result-item" v-for="(item, index) in resultList" :key="index" @click="goToDetail(item)">
                
                <div class="result-content">
                  <h4 class="result-title" v-html="highlightKeyword(item.searchTitle)"></h4>
                  <div class="result-meta">
                    <span v-if="item.searchDate"><i class="el-icon-time"></i> {{ formatSearchDate(item) }}</span>
                    <span v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.searchVisits || 0 }} 浏览</span>
                    <span class="type-tag" :class="getTypeClass(item.searchType)">{{ getTypeName(item.searchType) }}</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-else class="empty-state">
               <el-empty description="暂无搜索结果，请尝试更换关键词或筛选条件"></el-empty>
            </div>

            <!-- Pagination -->
            <div class="pagination-wrapper" v-if="resultList.length > 0">
              <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="total"
                :current-page.sync="searchForm.pageNum"
                :page-size="searchForm.pageSize"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getGlobalSearchList, getBannerList } from '@/api/menu'

export default {
  name: 'Search',
  data() {
    return {
      searchForm: {
        keyword: '',
        searchType: '',
        startDate: '',
        endDate: '',
        orderBy: '',
        pageNum: 1,
        pageSize: 8
      },
      dateRange: [],
      loading: false,
      resultList: [],
      total: 0,
      bannerSlides: [],
      currentBanner: 0,
    }
  },
  watch: {
    dateRange(val) {
      if (val && val.length === 2) {
        this.searchForm.startDate = val[0] + ' 00:00:00'
        this.searchForm.endDate = val[1] + ' 23:59:59'
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    // Watch for route query changes to update search results
    '$route.query.keyword': {
      handler(newVal) {
        if (newVal !== undefined) {
          this.searchForm.keyword = newVal || '';
          this.handleSearch();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  created() {
    // If URL has query params, apply them
    if (this.$route.query.keyword) {
      this.searchForm.keyword = this.$route.query.keyword;
    }
    this.fetchData();
    this.fetchBanner("qwjs");
  },
  methods: {
    startBannerTimer() {
      if (this.bannerTimer) clearInterval(this.bannerTimer);
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode });
        if (res.code === 0 || res.code === 200) {
          this.bannerSlides = res.rows || res.data || [];
          if (this.bannerSlides.length > 0) {
            this.currentBanner = 0;
          }
        }
      } catch (error) {
        console.error('获取轮播图失败', error);
      }
    },
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.fetchData();
    },
    handlePageChange(page) {
      this.searchForm.pageNum = page;
      this.fetchData();
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    resetSearch() {
      this.searchForm.keyword = '';
      this.searchForm.searchType = '';
      this.searchForm.orderBy = '';
      this.dateRange = [];
      this.searchForm.startDate = '';
      this.searchForm.endDate = '';
      this.searchForm.pageNum = 1;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      try {
        const res = await getGlobalSearchList(this.searchForm);
        if (res && res.code === 200) {
          this.resultList = res.rows || [];
          this.total = res.total || 0;
        }
      } catch (error) {
        console.error("Search failed:", error);
        this.$message.error('获取检索结果失败');
      } finally {
        this.loading = false;
      }
    },
    getTypeName(type) {
      const typeMap = {
        'AuctionAsset': '在拍资产',
        'BadAsset': '资产推介',
        'AyContent': '资讯中心',
        'CmsRecruitment': '人才招聘'
      };
      return typeMap[type] || '其他';
    },
    getTypeClass(type) {
      const classMap = {
        'AuctionAsset': 'tag-auction',
        'BadAsset': 'tag-badasset',
        'AyContent': 'tag-news',
        'CmsRecruitment': 'tag-career'
      };
      return classMap[type] || 'tag-default';
    },
    goToDetail(item) {
      const type = item.searchType;
      const id = item.id;
      if (!id) return;
      
      let routeOptions = {};
      
      if (type === 'AuctionAsset') {
        routeOptions = { path: '/auction/detail', query: { id: id } };
      } else if (type === 'BadAsset') {
        routeOptions = { path: '/property/detail', query: { id: id } };
      } else if (type === 'AyContent') {
        routeOptions = { path: '/news/detail', query: { id: id } };
      } else if (type === 'CmsRecruitment') {
        routeOptions = { path: '/careers/detail/' + id };
      }
      
      if (routeOptions.path) {
        const routeUrl = this.$router.resolve(routeOptions);
        window.open(routeUrl.href, '_blank');
      }
    },
    highlightKeyword(text) {
      if (!text) return '';
      if (!this.searchForm.keyword) return text;
      
      const keyword = this.searchForm.keyword.trim();
      if (!keyword) return text;
      
      const reg = new RegExp(`(${keyword})`, 'gi');
      return text.replace(reg, '<span style="color: #c0392b; font-weight: bold;">$1</span>');
    },
    formatSearchDate(item) {
      if (!item.searchDate) return '';
      if (item.searchDate.length >= 10) {
        return item.searchDate.substring(0, 10);
      }
      return item.searchDate;
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-red: #c0392b;
$primary-blue: #1e3a5f;
$text-main: #333333;
$text-secondary: #666666;
$text-light: #999999;
$border-color: #ebeef5;
.search-page {
  background-color: #ffffff;
  min-height: calc(100vh - 300px);
  padding-bottom: 60px;
}

/* ---- Banner 头图 (Assets.vue Style) ---- */
.page-banner {
  background-size: cover;
  background-color: $primary-blue;
  color: #fff;
  padding: 60px 0;
  position: relative;
  overflow: hidden;

  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    // transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

.search-section {
  margin-top: 30px;
  position: relative;
  z-index: 10;
}

.search-layout-centered {
  max-width: 1200px;
  margin: 0 auto;
}

.filter-section-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  margin-bottom: 30px;
}

.filter-box {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .filter-row {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed $border-color;
    padding-bottom: 15px;

    &.search-row {
      border-bottom: none;
      padding-bottom: 5px;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
      justify-content: space-between;
    }
  }
}

$search-bg: #f5f7fa;

.search-box-assets {
  display: flex;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  border: 1px solid $border-color;
  border-radius: 4px;
  overflow: hidden;

  input {
    flex: 1;
    border: none;
    padding: 12px 15px;
    outline: none;
    font-size: 0.95rem;
    background: $search-bg;
  }

  .btn-search {
    background: $primary-blue;
    color: #fff;
    border: none;
    padding: 0 30px;
    cursor: pointer;
    font-size: 0.95rem;
    // transition: background 0.2s;
    &:hover { background: lighten($primary-blue, 10%); }
  }
}

.filter-group {
  display: flex;
  align-items: flex-start;

  label {
    color: $text-main;
    flex-shrink: 0;
  }

  .filter-options {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
    
    ::v-deep .el-radio {
      margin-right: 25px;
      margin-top: 5px;
      margin-bottom: 5px;
      font-weight: normal;
      
      &.is-checked .el-radio__label {
        color: $primary-blue;
        font-weight: 600;
      }
      &.is-checked .el-radio__inner {
        border-color: $primary-blue;
        background: $primary-blue;
      }
    }
  }
}

.filter-actions {
  display: flex;
  gap: 10px;
  .saixuan {
    background-color: $primary-blue;
    border-color: $primary-blue;
    &:hover {
      background-color: lighten($primary-blue, 5%);
      border-color: lighten($primary-blue, 5%);
    }
  }
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0 20px;
}
.search-results {
  background: #fff;
  border-radius: 8px;
  padding: 30px 40px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.04);
  
  .result-header {
    border-bottom: 1px solid $border-color;
    padding-bottom: 15px;
    margin-bottom: 20px;
    font-size: 1.05rem;
    color: $text-main;
  }
  
  .result-list {
    display: flex;
    flex-direction: column;
    
    .result-item {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px dashed $border-color;
      cursor: pointer;
      // transition: all 0.3s;
      // align-items: flex-start;
      
      &:hover {
        ::v-deep .result-title {
          color: $primary-red;
        }
      }
      
      &:last-child {
        border-bottom: none;
      }
      
      // .result-type {
      //   margin-right: 20px;
      //   margin-top: 3px;
        
        .type-tag {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 4px;
          font-size: 0.85rem;
          font-weight: 500;
          white-space: nowrap;
          
          &.tag-auction { background-color: #fff1f0;color:#ed4b4b; }
          &.tag-badasset { background-color: #e9f3f9;color: #0896f5;}
          &.tag-news { background-color: #e1f2e1; color:#2bad2b;}
          &.tag-career { background-color: #f2e2f9;color: #cb61f5; }
          &.tag-default { background-color: #aaedf1;color:#25e4ee; }
        }
      // }
      
      .result-content {
        flex: 1;
        
        .result-title {
          font-size: 18px;
          color: $text-main;
          margin: 0 0 10px 0;
          line-height: 1.5;
          // transition: color 0.3s;
        }
        
        .result-meta {
          font-size: 0.9rem;
          color: $text-light;
          display: flex;
          align-items: center;
          gap: 15px;
          
          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
  
  .empty-state {
    padding: 60px 0;
  }
  
  .pagination-wrapper {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
}
::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1e3a5f !important;
  }
}
/* ================== 响应式适配 ================== */
@media (max-width: 1000px) {
  .page-banner {
    padding: 30px 0;
    h1 { font-size: 1.6rem; }
  }

  /* 筛选区整体缩小内边距 */
  .filter-section-wrapper {
    padding: 16px 14px;
    margin-bottom: 16px;
  }

  /* 筛选区纵向排列 */
  .filter-box {
    gap: 10px;

    .filter-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      padding-bottom: 12px;

      &.search-row { padding-bottom: 12px; }

      &:last-child {
        flex-direction: column;
      }
    }
  }

  /* 搜索框自适应 */
  .search-box-assets {
    max-width: 100%;

    input {
      padding: 10px 12px;
      font-size: 0.9rem;
    }

    .btn-search {
      padding: 0 16px;
      font-size: 0.85rem;
      white-space: nowrap;
    }
  }

  /* 筛选组横向排列 */
  .filter-group {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

    label {
      margin-bottom: 0;
      font-size: 0.9rem;
    }

    .filter-options {
      flex: 1;
      min-width: 0;
      flex-wrap: wrap;
      gap: 6px 12px;
    }

    /* Radio 按钮自适应 */
    ::v-deep .el-radio {
      margin-right: 10px;
      margin-top: 3px;
      margin-bottom: 3px;
    }

    /* 日期选择器强制全宽（覆盖 inline style="width:350px"） */
    ::v-deep .el-date-editor {
      width: 100% !important;
    }
    ::v-deep .el-date-editor.el-input__inner {
      width: 100% !important;
    }
    ::v-deep .el-date-editor--daterange.el-input__inner {
      width: 100% !important;
    }
  }

  /* 筛选/重置按钮铺满 */
  .filter-actions {
    width: 100%;
    justify-content: center;
    margin-top: 4px;

    .el-button {
      flex: 1;
    }
  }

  /* 结果列表缩小内边距 */
  .search-results {
    padding: 16px 12px;

    .result-header {
      padding-bottom: 10px;
      margin-bottom: 14px;
      font-size: 0.95rem;
    }

    .result-list .result-item {
      flex-direction: column;
      padding: 14px 0;

      .result-content {
        .result-title {
          font-size: 15px;
          margin-bottom: 8px;
        }

        .result-meta {
          font-size: 0.8rem;
          flex-wrap: wrap;
          gap: 8px;
        }
      }
    }
  }

  .pagination-wrapper {
    margin-top: 24px;

    ::v-deep .el-pagination {
      .el-pagination__jump {
        display: none;
      }
    }
  }
}
</style>
